import Vue from 'vue'
import "@capacitor-community/firebase-analytics"
import {Plugins} from "@capacitor/core"

const {FirebaseAnalytics} = Plugins


Vue.use(FirebaseAnalytics)
